import api from '@/api'

var Q = require('q')

const state = {
  regions: []
}

const getters = {
  regions: (state) => state.regions
}

const mutations = {
  SET_REGIONS (state, regions) {
    state.regions = regions
  },
  ADD_REGION (state, region) {
    state.regions.push(region)
  },
  DELETE_REGION (state, region) {
    let index = state.regions.findIndex(x => x.ID_REGION === region.ID_REGION)
    if (index !== -1) {
      state.regions.splice(index, 1)
    }
  }
}

const actions = {
  async getRegions ({ commit }) {
    var deferred = Q.defer()

    try {
      const response = await api.region.getRegions()
      commit('SET_REGIONS', response.data)

      deferred.resolve()
    } catch (e) {
      console.error(e)
      deferred.reject()
    }

    return deferred.promise
  },

  async createRegion ({ commit, dispatch }, data) {
    var deferred = Q.defer()

    try {
      const { file, fileItem, region, gridSize, progressCallback } = data

      const formData = new FormData()
      formData.append('file', file)
      formData.append('FICHERO', JSON.stringify(fileItem))
      formData.append('REGION', JSON.stringify(region))
      formData.append('GRIDSIZE', gridSize)

      /* const response = */ await api.region.createRegion(formData, progressCallback)

      // commit('ADD_REGION', region)
      // dispatch('getRegions') // Update files TODO: do it locally against the store??
      // dispatch('file/getFiles', null, { root: true }) // Update files TODO: do it locally against the store??

      deferred.resolve()
    } catch (e) {
      console.error(e)
      deferred.reject()
    }

    return deferred.promise
  },

  async deleteRegion ({ commit, dispatch }, region) {
    var deferred = Q.defer()

    try {
      /* const response = */ await api.region.deleteRegion(region)
      commit('DELETE_REGION', region)

      dispatch('file/getFiles', null, { root: true }) // Update files TODO: do it locally against the store??

      deferred.resolve()
    } catch (e) {
      console.error(e)
      deferred.reject()
    }

    return deferred.promise
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
